import { Row, Col } from "react-bootstrap";
import TeamMemberIndicator from "./TeamMemberIndicator";
import "./TeamMemberIndicatorsList.css";

function TeamMemberIndicatorsList({ indicators, language }) {
  return (
    <Col className="indicators-list">
      <Row>
        {indicators.map((element) => (
          <TeamMemberIndicator
            key={element._id}
            id={element._id}
            description={element.description}
            weight={element.weight}
            level={element.level}
            status={element.status}
            lastCheckInLevel={element.lastCheckInLevel}
            lastCheckInCompleted={element.lastCheckInCompleted}
            lastCheckInDate={element.lastCheckInDate}
            minRange={element.minRange}
            maxRange={element.maxRange}
            type={element.type}
            completed={element.completed}
            checkInsLength={element.checkIns.length}
            language={language}
          />
        ))}
      </Row>
    </Col>
  );
}

export default TeamMemberIndicatorsList;
